import '../App.css';
import { lazy, Suspense } from 'react';
import Header from './Header';
import Hero from './hero/Hero';
import SEO from './SEO';
import StructuredData from './StructuredData';

// Lazy load components ที่ไม่ได้อยู่ใน viewport เริ่มต้น
const Vector = lazy(() => import('./Vector'));
const HeroDestiantion = lazy(() => import('./hero/HeroDestiantion'));
const Service = lazy(() => import('./hero/Service'));
const ServiceList = lazy(() => import('./ServiceList'));
const SEOContent = lazy(() => import('./SEOContent'));
const QuickLinks = lazy(() => import('./QuickLinks'));
const Testimonials = lazy(() => import('./Testimonials'));
const Footer = lazy(() => import('./Footer'));

const Home =()=>{
    // Bootstrap CSS ถูกโหลดใน index.html แล้วเพื่อให้ UI แสดงผลถูกต้องทันที
    // Bootstrap JS ไม่จำเป็นในหน้าแรก (Modal ใช้ในหน้าอื่น)

    return(
       <>
        <SEO 
            title="TaxiUbr Thailand | เช่ารถพร้อมคนขับ แท็กซี่มิเตอร์ เหมารถทั่วประเทศ"
            description="แท็กซี่ขอนแก่น บริการเช่ารถพร้อมคนขับ แท็กซี่มิเตอร์ เหมารถทั่วประเทศ รับส่งสนามบินขอนแก่น แท็กซี่บขส 3 บริการ 24 ชั่วโมง ราคาถูก บริการดี น่าเชื่อถือ ปลอดภัย โทร 095-221-5764"
            keywords="แท็กซี่ขอนแก่น, รถเช่าขอนแก่น, เหมารถขอนแก่น, แท็กซี่รับส่งสนามบินขอนแก่น, แท็กซี่บขส 3 ขอนแก่น, รถเช่าพร้อมคนขับขอนแก่น, แท็กซี่มิเตอร์, แท็กซี่เหมาขอนแก่น, รถตู้เช่าขอนแก่น, รับส่งสนามบินขอนแก่น, บริการแท็กซี่ 24 ชั่วโมงขอนแก่น, เช่ารถรายวันขอนแก่น, เช่ารถรายชั่วโมงขอนแก่น, เหมารถไปต่างจังหวัดขอนแก่น, รับส่งโรงแรมขอนแก่น, Taxi Khon Kaen, Car rental Khon Kaen"
            url="/"
        />
        {/* LocalBusiness Schema */}
        <StructuredData 
            type="LocalBusiness"
            data={{
                name: "TaxiUbr Thailand",
                image: "https://www.taxiubr.com/logo-black-circle.png",
                description: "บริการแท็กซี่มิเตอร์และเช่ารถพร้อมคนขับ",
                telephone: "095-221-5764",
                url: "https://www.taxiubr.com",
                streetAddress: "281 58 หมู่ที่ 17 ถ. มิตรภาพ ตำบลในเมือง",
                addressLocality: "อำเภอเมืองขอนแก่น",
                addressRegion: "ขอนแก่น",
                addressCountry: "TH",
                postalCode: "40000",
                latitude: "16.4419",
                longitude: "102.8350",
                facebook: "https://www.facebook.com/profile.php?id=61556482434476",
                line: "https://line.me/R/ti/p/@sanookcar",
                openingHours: "00:00-23:59",
                priceRange: "$$",
                aggregateRating: {
                    "@type": "AggregateRating",
                    "ratingValue": "4.8",
                    "reviewCount": "150"
                },
                review: [
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "คุณสมชาย"
                        },
                        "datePublished": "2024-01-15",
                        "reviewBody": "บริการดีมาก คนขับขับรถดี ปลอดภัย ราคาเป็นธรรม แนะนำเลยครับ",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "5",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    },
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "คุณสุนิสา"
                        },
                        "datePublished": "2024-01-10",
                        "reviewBody": "ใช้บริการหลายครั้งแล้ว รถสะอาด คนขับสุภาพ บริการดีมากค่ะ",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "5",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    },
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "คุณประเสริฐ"
                        },
                        "datePublished": "2024-01-05",
                        "reviewBody": "เหมารถไปต่างจังหวัด ราคาดี บริการดี คนขับรู้เส้นทางดีมาก",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "5",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    },
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "คุณมาลี"
                        },
                        "datePublished": "2023-12-28",
                        "reviewBody": "จองล่วงหน้าได้สะดวกมาก รถมาถึงตรงเวลา บริการดีมากเลย",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "5",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    },
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "คุณวิทยา"
                        },
                        "datePublished": "2023-12-20",
                        "reviewBody": "ใช้บริการรถตู้เช่าขอนแก่น พาไปเที่ยวหลายที่ คนขับแนะนำสถานที่เที่ยวดีมาก",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "5",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    },
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "คุณนภา"
                        },
                        "datePublished": "2023-12-15",
                        "reviewBody": "บริการ 24 ชั่วโมงดีมาก โทรไปตอนดึกก็มีรถมารับทันที",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "5",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    }
                ]
            }}
        />
        <StructuredData 
            type="Organization"
            data={{
                name: "TaxiUbr Thailand",
                url: "https://www.taxiubr.com",
                logo: "https://www.taxiubr.com/logo-black-circle.png",
                telephone: "095-221-5764",
                facebook: "https://www.facebook.com/profile.php?id=61556482434476",
                line: "https://line.me/R/ti/p/@sanookcar"
            }}
        />
        
        {/* Service Schema */}
        <StructuredData 
            type="Service"
            data={{
                name: "บริการแท็กซี่มิเตอร์ขอนแก่น",
                providerName: "TaxiUbr Thailand",
                areaServed: "Khon Kaen, Thailand",
                offers: {
                    priceCurrency: "THB",
                    price: "35-40"
                }
            }}
        />
        
        {/* FAQ Schema for Homepage - Combined all questions (8 price/service + 3 contact/airport) */}
        <StructuredData 
            type="FAQPage"
            data={{
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "ราคาเช่ารถขอนแก่นเท่าไหร่?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "ราคาเช่ารถขอนแก่นขึ้นอยู่กับประเภทของรถ ระยะทาง และระยะเวลาในการใช้งาน สำหรับแท็กซี่เหมาขอนแก่น ราคาเริ่มต้นที่ 500-800 บาทต่อวัน ส่วนรถตู้เช่าขอนแก่นราคาเริ่มต้นที่ 1,500-2,500 บาทต่อวัน สอบถามราคาที่แน่นอนได้ที่ 095-221-5764"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "เช่ารถขอนแก่นต้องทำอะไรบ้าง?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "สำหรับการเช่ารถขอนแก่นพร้อมคนขับ คุณเพียงแค่โทรมาสอบถามและจองล่วงหน้า เราไม่ต้องการเอกสารมากมาย เพียงแจ้งจุดรับ-ส่ง วันที่และเวลา เราจะจัดหารถและคนขับให้ทันที บริการของเราสะดวก รวดเร็ว และไม่ยุ่งยาก"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "ทำไมต้องเช่ารถขอนแก่น?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "การเช่ารถขอนแก่นพร้อมคนขับช่วยให้คุณประหยัดเวลา ไม่ต้องกังวลเรื่องการขับรถเอง มีคนขับมืออาชีพที่รู้เส้นทางดี และสามารถให้คำแนะนำสถานที่ท่องเที่ยวได้ เหมาะสำหรับการเดินทางไปต่างจังหวัด การรับส่งสนามบิน หรือการนำเที่ยว"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "เหมาแท็กซี่ขอนแก่นเสียค่าใช้จ่ายอย่างไร?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "ค่าใช้จ่ายเหมาแท็กซี่ขอนแก่นจะคำนวณตามระยะทางและเวลา ราคาเหมาแท็กซี่ขอนแก่นจะคุ้มกว่าการใช้มิเตอร์สำหรับการเดินทางระยะไกลหรือการเหมาทั้งวัน เรามีราคาที่เป็นธรรมและโปร่งใส สอบถามราคาได้ที่ 095-221-5764"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "เหมารถไปต่างจังหวัดขอนแก่นราคาเท่าไหร่?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "ราคาเหมารถไปต่างจังหวัดขอนแก่นขึ้นอยู่กับจุดหมายปลายทาง ระยะทาง และประเภทของรถ เช่น เหมารถไปกรุงเทพ เหมารถไปพัทยา หรือเหมารถไปหนองคาย ราคาจะแตกต่างกัน สอบถามราคาที่แน่นอนได้ที่ 095-221-5764"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "รถตู้เช่าขอนแก่นนั่งได้กี่คน?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "รถตู้เช่าขอนแก่นของเรามีหลายขนาด ตั้งแต่ 7 ที่นั่ง 10 ที่นั่ง และ 13 ที่นั่ง เหมาะสำหรับครอบครัว กลุ่มเพื่อน หรือคณะทัวร์ สามารถเลือกขนาดรถตามจำนวนผู้โดยสารได้"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "บริการแท็กซี่ขอนแก่นติดต่อเบอร์อะไร?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "ติดต่อได้ที่เบอร์ 095-221-5764 ตลอด 24 ชั่วโมงครับ"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "มีบริการรับส่งสนามบินไหม?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "มีบริการรับส่งสนามบินขอนแก่นและสนามบินทั่วประเทศแบบจองล่วงหน้าครับ"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "รับส่งสนามบินขอนแก่นจองล่วงหน้าได้ไหม?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "ได้ครับ เรารับจองรับส่งสนามบินขอนแก่นล่วงหน้าได้ เพื่อความสะดวกและมั่นใจว่าจะมีรถมารับตรงเวลา แนะนำให้จองล่วงหน้าอย่างน้อย 1-2 วัน หรือโทรมาสอบถามได้ตลอด 24 ชั่วโมง"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "บริการแท็กซี่ 24 ชั่วโมงขอนแก่นมีไหม?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "มีครับ เรามีบริการแท็กซี่ 24 ชั่วโมงขอนแก่น พร้อมให้บริการทุกเวลา ไม่ว่าจะเป็นกลางวันหรือกลางคืน สามารถโทรมาสั่งรถได้ตลอด 24 ชั่วโมงที่ 095-221-5764"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "คิดค่าบริการอย่างไร?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "คิดตามระยะทางจริงหรือราคาเหมาจ่ายตามที่ตกลงกันก่อนเดินทางครับ"
                        }
                    }
                ]
            }}
        />
        <div className='main'>
            <Suspense fallback={null}>
                <Vector />
            </Suspense>
            <Header />
            <div className='content'>
            <Hero/>
            <div className='content-wrap'>
                <Suspense fallback={null}>
                    <HeroDestiantion />
                </Suspense>
                <Suspense fallback={null}>
                    <Service/>
                </Suspense>
                <Suspense fallback={null}>
                    <ServiceList/>
                </Suspense>
            </div>
            </div>
            <Suspense fallback={null}>
                <SEOContent />
            </Suspense>
            <Suspense fallback={null}>
                <QuickLinks />
            </Suspense>
            <Suspense fallback={null}>
                <Testimonials />
            </Suspense>
            <Suspense fallback={null}>
                <Footer/>
            </Suspense>
        </div>
      </>
    )
}
export default Home